// @flow
'use strict';

import * as React from 'react';
import { FormSection } from 'redux-form/lib/immutable';

import SelecaoTodosNfe from '../../form_exportacao_nfe/campos_nfe/selecao_todos_nfe';
import { Input } from '../../../../../../common/input';

type CamposItemProps = {
  component : React.ComponentType<*>,
}

export default function CamposTotalItem({ component } : CamposItemProps) {
  const SelecaoTodos = component || SelecaoTodosNfe;

  return (
      <FormSection name="dadosTotalItem">
        <SelecaoTodos nomes={ ["dadosTotalItem"] } titulo="Total do Item da NFe"/>

        <div className="grupo-checkbox">
          <Input name="valorTotalItemNfe" label="Valor Total do Item da NFe" checkbox/>
        </div>
      </FormSection>
  );
}